import { z } from 'zod';

const envSchema = z.object({
  LOMA_URL: z.string(),
  NOFLAKE_URL: z.string(),
  RETURNS_PORTAL_URL_TEMPLATE: z.string(),
  TITAN_URL: z.string(),
  FULLSTORY_ORG_ID: z.string(),
  FULLSTORY_INCLUDE_PERCENTAGE: z.string(),
  CSP_CLAIM_UPDATED_POLLING_INTERVAL_MS: z.string(),
  CSP_CLAIM_UPDATED_POLLING_TIMEOUT_MS: z.string(),
  CLAIM_UPDATED_POLLING_INTERVAL_MS: z.string(),
  CLAIM_UPDATED_POLLING_TIMEOUT_MS: z.string(),
  DD_CLIENT_TOKEN: z.string().optional(),
  DD_ENV: z.enum(['na01', 'na01-staging', 'qa04']).optional(),
  NODE_ENV: z.string().optional(),
});

export default envSchema.parse(process.env);
